const API = "https://apis.hustlemad.com";
// const API = "http://localhost:4000";
module.exports = { API };
